export default __webpack_public_path__ + "static/media/cocina.eddb71b9.png";